
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue12 as ObiWindTrue12Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-12.js';
 
 
 

 
 export const ObiWindTrue12 = createComponent({
   react: React,
   tagName: 'obi-wind-true-12',
   elementClass: ObiWindTrue12Element,
   events: {
     
   }
  });
 
 